// import project1 from '../Images/azizi_milan.webp'
// import project2 from '../Images/azizi_veniece.webp'
// import project3 from '../Images/00_Hero.webp'
// import project4 from '../Images/Tilal-by-Binghatti-9.jpeg'
// import project5 from '../Images/12.jpg'
// import project6 from '../Images/img6-scaled.webp'

// const images = [project1, project2, project3, project4, project5, project6]

// export const projectsData = [
  
 
 
//   {
//     id: 13,
//     name: { ar: 'عزيزي ميلان', en: 'Azizi Milan' },
//     developer: 'Azizi',
//     location: { ar: 'مدينة العرب', en: 'City Of Arabia' },
//     price: 624000,
//     image: images[0],
//     sqft: 320,
//     types: ['studio', 'bedroom1', 'bedroom2', 'bedroom3'],
//     amenities: ['pool', 'gym', 'parking', 'security', 'jogging', 'kidsArea', 'restaurant', 'mall', 'tennis', 'garden', 'playground', 'yoga'],
//     paymentPlan: {
//       downPayment: 10,
//       duringConstruction: 50,
//       onHandover: 40,
//     },
//     handover: 'Q2-2027',
//     nearbyPlaces: [
//       { name: { ar: 'مطار دبي الدولي', en: 'Dubai International Airport' }, time: '25 Minutes' },
//       { name: { ar: 'حديقة دبي ميراكل جاردن', en: 'Dubai Miracle Garden' }, time: '15 Minutes' },
//       { name: { ar: 'القرية العالمية', en: 'Global Village' }, time: '05 Minutes' },
//       { name: { ar: 'آي إم جي وورلد أوف أدفنتشر', en: 'IMG World of Adventure' }, time: '01 Minute' },
//     ],
//     floorPlan: [
//       {
//         category: '15TH FLOOR to 4TH FLOOR',
//         unitType: 'Studio',
//         floorDetails: 'TYPE-01A (UNIT 320) to TYPE-07 (UNIT 213)',
//         sizes: '278.46 to 561.99 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '1ST FLOOR to 8TH FLOOR',
//         unitType: '1 Bedroom',
//         floorDetails: 'TYPE-01A (UNIT 2609) to TYPE-03E (UNIT 107)',
//         sizes: '663.17 to 1212.13 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '3RD FLOOR to 4TH FLOOR',
//         unitType: '2 Bedrooms',
//         floorDetails: 'TYPE-01A (UNIT 324) to TYPE-01C (UNIT 424)',
//         sizes: '1121.50 to 1159.61 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '7TH & 8TH FLOORS',
//         unitType: '2 Bedrooms + Maid',
//         floorDetails: 'TYPE-01A (UNIT 704) to TYPE-01B (UNIT 705)',
//         sizes: '2999.50 to 3020.38 Sq Ft',
//         type: 'Duplex Apartments',
//       },
//     ],
//   },
//   {
//     id: 14,
//     name: { ar: 'عزيزي فينيسيا', en: 'Azizi Venice' },
//     developer: 'Azizi',
//     location: { ar: 'جنوب دبي', en: 'Dubai South' },
//     price: 758000,
//     image: images[1],
//     sqft: 332.82,
//     types: ['studio', 'bedroom1', 'bedroom2', 'bedroom3'],
//     amenities: ['pool', 'gym', 'parking', 'security', 'kidsArea', 'restaurant', 'jogging', 'beach', 'mall', 'playground'],
//     paymentPlan: {
//       downPayment: 20,
//       duringConstruction: 20,
//       onHandover: 60,
//     },
//     handover: 'Q4-2027',
//     nearbyPlaces: [
//       { name: { ar: 'مطار آل مكتوم الدولي', en: 'Al Maktoum International Airport' }, time: '7 mins' },
//       { name: { ar: 'دبي مارينا', en: 'Dubai Marina' }, time: '25 mins' },
//       { name: { ar: 'دبي باركس آند ريزورتس', en: 'Dubai Park & Resorts' }, time: '15 mins' },
//       { name: { ar: 'طريق الإمارات', en: 'Emirates Road' }, time: '5 mins' },
//       { name: { ar: 'مول الإمارات', en: 'Mall of the Emirates' }, time: '30 mins' },
//       { name: { ar: 'نخلة جبل علي', en: 'Palm Jebel Ali' }, time: '25 mins' },
//     ],
//     floorPlan: [
//       {
//         category: 'Floor Plan',
//         unitType: '—',
//         floorDetails: '1st Floor',
//         sizes: 'On Request',
//         type: 'Apartment',
//       },
//       {
//         category: 'Floor Plan',
//         unitType: '—',
//         floorDetails: '2nd To 5th & 8th To 10th Floor',
//         sizes: 'On Request',
//         type: 'Apartment',
//       },
//       {
//         category: 'Floor Plan',
//         unitType: '—',
//         floorDetails: '6th To 7th Floor',
//         sizes: 'On Request',
//         type: 'Apartment',
//       },
//       {
//         category: 'Floor Plan',
//         unitType: '—',
//         floorDetails: 'Roof Floor',
//         sizes: 'On Request',
//         type: 'Apartment',
//       },
//       {
//         category: 'Floor Plan',
//         unitType: '—',
//         floorDetails: 'Top Floor',
//         sizes: 'On Request',
//         type: 'Apartment',
//       },
//     ],
//   },
//   {
//     id: 15,
//     name: { ar: 'أزيزي ريفييرا ميدان', en: 'Azizi Riviera Meydan' },
//     developer: 'Azizi',
//     location: { ar: 'محمد بن راشد سيتي', en: 'Mohammed Bin Rashid City' },
//     price: 650000,
//     image: images[2],
//     sqft: 343.91,
//     types: ['studio', 'bedroom1', 'bedroom2', 'bedroom3'],
//     amenities: ['pool', 'gym', 'kidsArea', 'garden', 'mall', 'restaurant'],
//     paymentPlan: 'callUs',
//     handover: 'Ready to Move in',
//     nearbyPlaces: [
//       { name: { ar: 'خليج الأعمال', en: 'Business Bay' }, time: '10 Minutes' },
//       { name: { ar: 'داون تاون دبي', en: 'Downtown Dubai' }, time: '07 Minutes' },
//       { name: { ar: 'حي دبي للتصميم', en: 'Dubai Design District' }, time: '05 Minutes' },
//       { name: { ar: 'مطار دبي الدولي', en: 'Dubai International Airport' }, time: '10 Minutes' },
//       { name: { ar: 'مركز دبي المالي العالمي', en: 'Dubai International Financial Centre (DIFC)' }, time: '10 Minutes' },
//       { name: { ar: 'ميدان لسباق الخيل', en: 'Meydan Racecourse' }, time: '01 Minute' },
//       { name: { ar: 'متحف المستقبل', en: 'Museum Of The Future' }, time: '10 Minutes' },
//       { name: { ar: 'نخلة جميرا', en: 'Palm Jumeirah' }, time: '20 Minutes' },
//     ],
//     floorPlan: [
//       {
//         category: 'STUDIO',
//         unitType: '—',
//         floorDetails: 'STUDIO Type 1 to STUDIO Type 2, First Floor',
//         sizes: '380.39 to 492.77 Sq Ft',
//         type: '—',
//       },
//       {
//         category: 'Studio',
//         unitType: 'Studio',
//         floorDetails: 'Studio',
//         sizes: '350.00 to 350.00 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '1 Bedroom',
//         unitType: '—',
//         floorDetails: '1 Bedroom Type 1 to 1 Bedroom Type 4, 1st Floor Plan',
//         sizes: '699.32 to 1120.62 Sq Ft',
//         type: '—',
//       },
//       {
//         category: '1 Bedroom',
//         unitType: '1 Bedroom',
//         floorDetails: '1 Bedroom to 1 Bedroom Type 2, 2nd to 9th Typical Floor',
//         sizes: '550.00 to 779.83 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '2 Bedroom',
//         unitType: '2 Bedrooms',
//         floorDetails: '2 Bedroom',
//         sizes: '800.00 to 800.00 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '3 Bedroom',
//         unitType: '3 Bedrooms',
//         floorDetails: '3 Bedroom',
//         sizes: '1100.00 to 1100.00 Sq Ft',
//         type: 'Apartment',
//       },
//     ],
//   },
//   {
//     id: 16,
//     name: { ar: 'تلال بينجاتي', en: 'Tilal Binghatti' },
//     developer: 'Binghatti',
//     location: { ar: 'المدينة الأكاديمية', en: 'Academic City' },
//     price: 4200000,
//     image: images[3],
//     sqft: null,
//     types: ['bedroom4', 'villa'],
//     amenities: ['beach', 'pool', 'kidsArea', 'garden', 'tennis'],
//     nearbyPlaces: [
//       { name: { ar: 'ميدان لسباق الخيل', en: 'Meydan Racecourse' }, time: '10 Minutes' },
//       { name: { ar: 'برج خليفة ودبي مول', en: 'Burj Khalifa & Dubai Mall' }, time: '7 Minutes' },
//       { name: { ar: 'ميناء دبي الحرفي', en: 'Dubai Creek Harbour' }, time: '15 Minutes' },
//     ],
//   },
//   {
//     id: 17,
//     name: { ar: 'بينجاتي مرسيدس بنز بليسز', en: 'Binghatti Mercedes Benz Places' },
//     developer: 'Binghatti',
//     location: { ar: 'داون تاون دبي', en: 'Downtown Dubai' },
//     price: 8900000,
//     image: images[4],
//     sqft: 1586,
//     types: ['bedroom2', 'bedroom3', 'bedroom4', 'penthouse'],
//     amenities: ['beach', 'restaurant', 'gym', 'kidsArea', 'garden', 'pool', 'mall'],
//     paymentPlan: {
//       downPayment: 20,
//       duringConstruction: 50,
//       onHandover: 30,
//     },
//     handover: 'Q4-2026',
//     nearbyPlaces: [
//       { name: { ar: 'برج خليفة', en: 'Burj Khalifa' }, time: '15 Minutes' },
//       { name: { ar: 'مطار دبي الدولي', en: 'Dubai International Airport' }, time: '10 Minutes' },
//       { name: { ar: 'مركز دبي المالي العالمي', en: 'Dubai International Financial Centre (DIFC)' }, time: '05 Minutes' },
//       { name: { ar: 'دبي أوبرا', en: 'Dubai Opera' }, time: '20 Minutes' },
//       { name: { ar: 'دبي مول', en: 'The Dubai Mall' }, time: '10 Minutes' },
//     ],
//     floorPlan: [
//       {
//         category: 'Layout Plan',
//         unitType: '—',
//         floorDetails: 'Duplex Penthouse',
//         sizes: 'Various Sizes',
//         type: 'Duplex Penthouses',
//       },
//       {
//         category: 'Layout Plan',
//         unitType: '—',
//         floorDetails: 'Level 1 to The Triplex Penthouse',
//         sizes: '0.00 to 6437.00 Sq Ft',
//         type: 'Triplex Penthouse',
//       },
//       {
//         category: '2 Bedroom',
//         unitType: '2 Bedrooms + Maid',
//         floorDetails: '2 Bedroom to Type 2-A',
//         sizes: '0.00 to 2534.00 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '3 Bedroom',
//         unitType: '3 Bedrooms + Maid',
//         floorDetails: '3 Bedroom to Type 2',
//         sizes: '0.00 to 3285.00 Sq Ft',
//         type: 'Apartment',
//       },
//       {
//         category: '3 Bedroom',
//         unitType: '3 Bedrooms + Maid',
//         floorDetails: 'Level 1 to Level 2',
//         sizes: '5566.00 to 6909.00 Sq Ft',
//         type: 'Duplex Penthouses',
//       },
//       {
//         category: '4 Bedroom',
//         unitType: '4 Bedrooms + Maid',
//         floorDetails: '4 Bedroom to Type 1-A',
//         sizes: '0.00 to 3007.00 Sq Ft',
//         type: 'Penthouse',
//       },
//       {
//         category: '5 Bedroom',
//         unitType: '5 Bedrooms + Maid',
//         floorDetails: '5 Bedroom',
//         sizes: '0.00 to 6891.00 Sq Ft',
//         type: 'Penthouse',
//       },
//     ],
//   },
// ]

// export const getUniqueDevelopers = () => [...new Set(projectsData.map((p) => p.developer))]
// export const getUniqueLocations = (lang) => [...new Set(projectsData.map((p) => p.location[lang]))]













import project1 from '../Images/azizi_milan.webp'
import project2 from '../Images/azizi_veniece.webp'
import project3 from '../Images/00_Hero.webp'
import project4 from '../Images/Tilal-by-Binghatti-9.jpeg'
import project5 from '../Images/12.jpg'
import project6 from '../Images/azizi-florence-villa-exterior-1.webp'

const images = [project1, project2, project3, project4, project5, project6]

export const projectsData = [
  
  {
    id: 13,
    name: { ar: 'عزيزي ميلان', en: 'Azizi Milan' },
    developer: 'Azizi',
    location: { ar: 'مدينة العرب', en: 'City Of Arabia' },
    price: 624000,
    image: images[0],
    sqft: 320,
    types: ['studio', 'bedroom1', 'bedroom2', 'bedroom3'],
    amenities: ['pool', 'gym', 'parking', 'security', 'jogging', 'kidsArea', 'restaurant', 'mall', 'tennis', 'garden', 'playground', 'yoga'],
    paymentPlan: {
      downPayment: 10,
      duringConstruction: 50,
      onHandover: 40,
    },
    handover: 'Q2-2027',
    nearbyPlaces: [
      { name: { ar: 'مطار دبي الدولي', en: 'Dubai International Airport' }, time: '25 Minutes' },
      { name: { ar: 'حديقة دبي ميراكل جاردن', en: 'Dubai Miracle Garden' }, time: '15 Minutes' },
      { name: { ar: 'القرية العالمية', en: 'Global Village' }, time: '05 Minutes' },
      { name: { ar: 'آي إم جي وورلد أوف أدفنتشر', en: 'IMG World of Adventure' }, time: '01 Minute' },
    ],
    floorPlan: [
      {
        category: '15TH FLOOR to 4TH FLOOR',
        unitType: 'Studio',
        floorDetails: 'TYPE-01A (UNIT 320) to TYPE-07 (UNIT 213)',
        sizes: '278.46 to 561.99 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '1ST FLOOR to 8TH FLOOR',
        unitType: '1 Bedroom',
        floorDetails: 'TYPE-01A (UNIT 2609) to TYPE-03E (UNIT 107)',
        sizes: '663.17 to 1212.13 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '3RD FLOOR to 4TH FLOOR',
        unitType: '2 Bedrooms',
        floorDetails: 'TYPE-01A (UNIT 324) to TYPE-01C (UNIT 424)',
        sizes: '1121.50 to 1159.61 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '7TH & 8TH FLOORS',
        unitType: '2 Bedrooms + Maid',
        floorDetails: 'TYPE-01A (UNIT 704) to TYPE-01B (UNIT 705)',
        sizes: '2999.50 to 3020.38 Sq Ft',
        type: 'Duplex Apartments',
      },
    ],
  },
  {
    id: 14,
    name: { ar: 'عزيزي فينيسيا', en: 'Azizi Venice' },
    developer: 'Azizi',
    location: { ar: 'جنوب دبي', en: 'Dubai South' },
    price: 758000,
    image: images[1],
    sqft: 332.82,
    types: ['studio', 'bedroom1', 'bedroom2', 'bedroom3'],
    amenities: ['pool', 'gym', 'parking', 'security', 'kidsArea', 'restaurant', 'jogging', 'beach', 'mall', 'playground'],
    paymentPlan: {
      downPayment: 20,
      duringConstruction: 20,
      onHandover: 60,
    },
    handover: 'Q4-2027',
    nearbyPlaces: [
      { name: { ar: 'مطار آل مكتوم الدولي', en: 'Al Maktoum International Airport' }, time: '7 mins' },
      { name: { ar: 'دبي مارينا', en: 'Dubai Marina' }, time: '25 mins' },
      { name: { ar: 'دبي باركس آند ريزورتس', en: 'Dubai Park & Resorts' }, time: '15 mins' },
      { name: { ar: 'طريق الإمارات', en: 'Emirates Road' }, time: '5 mins' },
      { name: { ar: 'مول الإمارات', en: 'Mall of the Emirates' }, time: '30 mins' },
      { name: { ar: 'نخلة جبل علي', en: 'Palm Jebel Ali' }, time: '25 mins' },
    ],
    floorPlan: [
      {
        category: 'Floor Plan',
        unitType: '—',
        floorDetails: '1st Floor',
        sizes: 'On Request',
        type: 'Apartment',
      },
      {
        category: 'Floor Plan',
        unitType: '—',
        floorDetails: '2nd To 5th & 8th To 10th Floor',
        sizes: 'On Request',
        type: 'Apartment',
      },
      {
        category: 'Floor Plan',
        unitType: '—',
        floorDetails: '6th To 7th Floor',
        sizes: 'On Request',
        type: 'Apartment',
      },
      {
        category: 'Floor Plan',
        unitType: '—',
        floorDetails: 'Roof Floor',
        sizes: 'On Request',
        type: 'Apartment',
      },
      {
        category: 'Floor Plan',
        unitType: '—',
        floorDetails: 'Top Floor',
        sizes: 'On Request',
        type: 'Apartment',
      },
    ],
  },
  {
    id: 15,
    name: { ar: 'أزيزي ريفييرا ميدان', en: 'Azizi Riviera Meydan' },
    developer: 'Azizi',
    location: { ar: 'محمد بن راشد سيتي', en: 'Mohammed Bin Rashid City' },
    price: 650000,
    image: images[2],
    sqft: 343.91,
    types: ['studio', 'bedroom1', 'bedroom2', 'bedroom3'],
    amenities: ['pool', 'gym', 'kidsArea', 'garden', 'mall', 'restaurant'],
    paymentPlan: 'callUs',
    handover: 'Ready to Move in',
    nearbyPlaces: [
      { name: { ar: 'خليج الأعمال', en: 'Business Bay' }, time: '10 Minutes' },
      { name: { ar: 'داون تاون دبي', en: 'Downtown Dubai' }, time: '07 Minutes' },
      { name: { ar: 'حي دبي للتصميم', en: 'Dubai Design District' }, time: '05 Minutes' },
      { name: { ar: 'مطار دبي الدولي', en: 'Dubai International Airport' }, time: '10 Minutes' },
      { name: { ar: 'مركز دبي المالي العالمي', en: 'Dubai International Financial Centre (DIFC)' }, time: '10 Minutes' },
      { name: { ar: 'ميدان لسباق الخيل', en: 'Meydan Racecourse' }, time: '01 Minute' },
      { name: { ar: 'متحف المستقبل', en: 'Museum Of The Future' }, time: '10 Minutes' },
      { name: { ar: 'نخلة جميرا', en: 'Palm Jumeirah' }, time: '20 Minutes' },
    ],
    floorPlan: [
      {
        category: 'STUDIO',
        unitType: '—',
        floorDetails: 'STUDIO Type 1 to STUDIO Type 2, First Floor',
        sizes: '380.39 to 492.77 Sq Ft',
        type: '—',
      },
      {
        category: 'Studio',
        unitType: 'Studio',
        floorDetails: 'Studio',
        sizes: '350.00 to 350.00 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '1 Bedroom',
        unitType: '—',
        floorDetails: '1 Bedroom Type 1 to 1 Bedroom Type 4, 1st Floor Plan',
        sizes: '699.32 to 1120.62 Sq Ft',
        type: '—',
      },
      {
        category: '1 Bedroom',
        unitType: '1 Bedroom',
        floorDetails: '1 Bedroom to 1 Bedroom Type 2, 2nd to 9th Typical Floor',
        sizes: '550.00 to 779.83 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '2 Bedroom',
        unitType: '2 Bedrooms',
        floorDetails: '2 Bedroom',
        sizes: '800.00 to 800.00 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '3 Bedroom',
        unitType: '3 Bedrooms',
        floorDetails: '3 Bedroom',
        sizes: '1100.00 to 1100.00 Sq Ft',
        type: 'Apartment',
      },
    ],
  },
  {
    id: 16,
    name: { ar: 'تلال بينجاتي', en: 'Tilal Binghatti' },
    developer: 'Binghatti',
    location: { ar: 'المدينة الأكاديمية', en: 'Academic City' },
    price: 4200000,
    image: images[3],
    sqft: null,
    types: ['bedroom4', 'villa'],
    amenities: ['beach', 'pool', 'kidsArea', 'garden', 'tennis'],
    nearbyPlaces: [
      { name: { ar: 'ميدان لسباق الخيل', en: 'Meydan Racecourse' }, time: '10 Minutes' },
      { name: { ar: 'برج خليفة ودبي مول', en: 'Burj Khalifa & Dubai Mall' }, time: '7 Minutes' },
      { name: { ar: 'ميناء دبي الحرفي', en: 'Dubai Creek Harbour' }, time: '15 Minutes' },
    ],
  },
  {
    id: 17,
    name: { ar: 'بينجاتي مرسيدس بنز بليسز', en: 'Binghatti Mercedes Benz Places' },
    developer: 'Binghatti',
    location: { ar: 'داون تاون دبي', en: 'Downtown Dubai' },
    price: 8900000,
    image: images[4],
    sqft: 1586,
    types: ['bedroom2', 'bedroom3', 'bedroom4', 'penthouse'],
    amenities: ['beach', 'restaurant', 'gym', 'kidsArea', 'garden', 'pool', 'mall'],
    paymentPlan: {
      downPayment: 20,
      duringConstruction: 50,
      onHandover: 30,
    },
    handover: 'Q4-2026',
    nearbyPlaces: [
      { name: { ar: 'برج خليفة', en: 'Burj Khalifa' }, time: '15 Minutes' },
      { name: { ar: 'مطار دبي الدولي', en: 'Dubai International Airport' }, time: '10 Minutes' },
      { name: { ar: 'مركز دبي المالي العالمي', en: 'Dubai International Financial Centre (DIFC)' }, time: '05 Minutes' },
      { name: { ar: 'دبي أوبرا', en: 'Dubai Opera' }, time: '20 Minutes' },
      { name: { ar: 'دبي مول', en: 'The Dubai Mall' }, time: '10 Minutes' },
    ],
    floorPlan: [
      {
        category: 'Layout Plan',
        unitType: '—',
        floorDetails: 'Duplex Penthouse',
        sizes: 'Various Sizes',
        type: 'Duplex Penthouses',
      },
      {
        category: 'Layout Plan',
        unitType: '—',
        floorDetails: 'Level 1 to The Triplex Penthouse',
        sizes: '0.00 to 6437.00 Sq Ft',
        type: 'Triplex Penthouse',
      },
      {
        category: '2 Bedroom',
        unitType: '2 Bedrooms + Maid',
        floorDetails: '2 Bedroom to Type 2-A',
        sizes: '0.00 to 2534.00 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '3 Bedroom',
        unitType: '3 Bedrooms + Maid',
        floorDetails: '3 Bedroom to Type 2',
        sizes: '0.00 to 3285.00 Sq Ft',
        type: 'Apartment',
      },
      {
        category: '3 Bedroom',
        unitType: '3 Bedrooms + Maid',
        floorDetails: 'Level 1 to Level 2',
        sizes: '5566.00 to 6909.00 Sq Ft',
        type: 'Duplex Penthouses',
      },
      {
        category: '4 Bedroom',
        unitType: '4 Bedrooms + Maid',
        floorDetails: '4 Bedroom to Type 1-A',
        sizes: '0.00 to 3007.00 Sq Ft',
        type: 'Penthouse',
      },
      {
        category: '5 Bedroom',
        unitType: '5 Bedrooms + Maid',
        floorDetails: '5 Bedroom',
        sizes: '0.00 to 6891.00 Sq Ft',
        type: 'Penthouse',
      },
    ],
  },
  {
    id: 18,
    name: { ar: 'أزيزي فلورنس', en: 'Azizi Florence' },
    developer: 'Azizi',
    location: { ar: 'أم فنين، الشارقة', en: 'Um Fanain, Sharjah' },
    price: 1890000,
    image: images[5],
    sqft: null,
    types: ['bedroom3', 'bedroom4', 'townhouse', 'villa'],
    amenities: ['jogging', 'playground', 'gym', 'pool', 'cinema', 'garden'],
    paymentPlan: {
      downPayment: 30,
      duringConstruction: 0,
      onHandover: 70,
    },
    nearbyPlaces: [
      { name: { ar: 'طريق محمد بن زايد (E311)', en: 'Mohammed Bin Zayed Road (E311)' }, time: '0 Mins' },
      { name: { ar: 'طريق الإمارات (E611)', en: 'Emirates Road (E611)' }, time: '10 Mins' },
      { name: { ar: 'مطار الشارقة الدولي', en: 'Sharjah International Airport' }, time: '10 Mins' },
      { name: { ar: 'المدينة الجامعية، الشارقة', en: 'University City, Sharjah' }, time: '10 Mins' },
      { name: { ar: 'داون تاون دبي', en: 'Downtown Dubai' }, time: '20 Mins' },
      { name: { ar: 'مطار دبي الدولي', en: 'Dubai International Airport' }, time: '20 Mins' },
    ],
  },
]

export const getUniqueDevelopers = () => [...new Set(projectsData.map((p) => p.developer))]
export const getUniqueLocations = (lang) => [...new Set(projectsData.map((p) => p.location[lang]))]